<template>
  <b-modal ref="modal"
           size="lg"
           centered
           hide-footer>
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.Reports.Type2}}
        </span>
        <button class="close" @click="onHide">x</button>
      </div>
    </template>
    <div class="d-flex align-items-center">
      <v-select label="descricao"
                :options="form.relatorio.options"
                v-model="form.relatorio.value"
                :reduce="value => value.id"
                @input="onSelectReport"
                class="flex-grow-1 mb-1 mr-2" />

      <b-link href="#" @click="onExport('XLS')">
        <i class="far fa-file-excel m-1" style="font-size:1.5rem;"></i>
      </b-link>
      <b-link v-if="pcis && pcis.length === 1" href="#" @click="onExport('PDF')">
        <i class="far fa-file-pdf m-1" style="font-size:1.5rem;"></i>
      </b-link>
    </div>
    <div style="width:100%;height:calc(60vh - 150px);">
      <ag-grid-vue class="ag-theme-alpine"
                  :getLocaleText="localeTextFunc"
                  :columnDefs="columnDefs"
                  :gridOptions="resumeGridOptions"
                  :defaultColDef="defaultColumnDef"
                  :rowData="objList"
                  :suppressContextMenu="true"
                  :stopEditingWhenCellsLoseFocus="true"
                  :groupHeaderHeight="45"
                  :headerHeight="45"
                  :rowHeight="30"
                  :excelStyles="excelStyles"
                  :groupDefaultExpanded="2"
                  groupDisplayType="groupRows"
                  style="width:100%;height:100%;">
      </ag-grid-vue>
    </div>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../../mixins/gridMixin'
import Form from './resume-form'
import { loading } from '@/shared/utils/UIHelper'
import PCIReportRepository from '@/shared/http/repositories/pci/pcireport'
import CompanyMixin from '@/store/module/company/mixin'
import PCIRepository from '@/shared/http/repositories/pci/pci'

export default {
  name: 'Resume',
  mixins: [gridMixin, CompanyMixin],
  components: {
    AgGridVue
  },
  data () {
    return {
      pcis: [],
      resumeGridOptions: {},
      form: Form,
      objList: [],
      columnDefs: [
        {
          headerName: 'Referencia',
          field: 'contract',
          hide: true,
          rowGroup: true,
          width: 250
        },
        {
          headerName: 'Item',
          valueGetter: params => {
            const result = params.data ? params.data.field : ''
            return result
          },
          cellClass: 'z-row-group',
          hide: true,
          rowGroup: true,
          width: 250
        },
        {
          headerName: 'Contrato',
          field: 'value',
          cellStyle: { 'padding-left': '100px' },
          width: 300
        },
        {
          headerName: 'Quantidade',
          field: 'qtd',
          type: 'numericColumn',
          width: 140
        }
      ]
    }
  },
  mounted () {
    this.loadReports()
  },
  methods: {
    loadReports () {
      loading.push()
      PCIReportRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.relatorio.options = response.data.data.filter(r => r.tipo === 2)
          }
        })
        .finally(() => loading.close())
    },
    show (pcis) {
      this.pcis = pcis
      this.form.relatorio.value = null
      this.$refs.modal.show()
      this.$nextTick(() => {
        this.resumeGridOptions.api.sizeColumnsToFit()
      })
    },
    onHide () {
      this.$emit('close')
      this.$refs.modal.hide()
    },
    onSelectReport () {
      if (this.form.relatorio.value) {
        loading.push()
        PCIRepository.GetResumeReport(this.form.relatorio.value, {params: {pcis: this.pcis}, paramsSerializer: {indexes: null}})
          .then(response => {
            if (response.data.code > 0) {
              const resume = response.data.data.map(r => {
                if (r.pciModeloItem.codigo > 0) {
                  return {contract: r.obra.contrato.referencia, field: `[${r.pciModeloItem.codigo}]-${r.pciModeloItem.descricao}`, value: r.valor}
                }
                return {contract: r.obra.contrato.referencia, field: `${r.pciModeloItem.descricao}`, value: r.valor}
              })
              const res = resume.filter(r => r.value).reduce((r, e) => {
                if (!r.some(arr => arr.field === e.field && arr.value === e.value)) {
                  r.push(
                    {
                      contract: e.contract,
                      field: e.field,
                      value: e.value,
                      qtd: 0
                    }
                  )
                }

                r[r.length - 1].qtd += 1

                return r
              }, [])
              this.objList = [...res]
              this.$nextTick(() => {
                setTimeout(() => {
                  this.resumeGridOptions.api.sizeColumnsToFit()
                }, 200)
              })
            }
          })
          .finally(() => loading.close())
      } else {
        this.objList = []
      }
    },
    onExport (type) {
      PCIRepository.GetResumeExport(this.form.relatorio.value, type, {params: {pcis: this.pcis}, paramsSerializer: {indexes: null}})
        .then(response => {
          if (response.data.code > 0) {
            const data = Buffer.from(response.data.data.file, 'base64')
            const blob = new Blob([data], {type: response.data.data.contentType + ';charset=utf-8;'})
            const fileUrl = window.URL.createObjectURL(blob)
            if (type === 'PDF') {
              window.open(fileUrl)
            } else {
              const link = document.createElement('a')
              link.href = fileUrl
              link.download = response.data.data.name
              link.click()
            }
            URL.revokeObjectURL(fileUrl)
          }
        })
    }
  }
}
</script>

<style scoped>
  * >>> .ag-header-cell {
    background-color: #008144;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/resume/resume.vue